import { render } from "./detail.vue?vue&type=template&id=5810108f&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=5810108f&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5810108f"],['__file',"src/views/mediaLibrary/item/detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5810108f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5810108f', __exports__)) {
    console.log('reload')
    api.reload('5810108f', __exports__)
  }
  
  module.hot.accept("./detail.vue?vue&type=template&id=5810108f&scoped=true", () => {
    console.log('re-render')
    api.rerender('5810108f', render)
  })

}


export default __exports__